import React, {
    useCallback, useContext
} from 'react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from 'e1p-portals-wizard-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import metadata from '../ThirdPartyInterestPage.metadata.json5';

function ViewThirdPartyInterestPage(props) {
    const {
        wizardData: policyChangeVM,
        updateWizardData
    } = props;
    const { authHeader } = useAuthentication();
    const { onValidate } = useValidation('ViewThirdPartyInterestPage');
    const viewModelService = useContext(ViewModelServiceContext);

    /**
     * Helper callback for handling wizard page navigation after the "Next" button is pressed.
     */
    const onNext = useCallback(() => policyChangeVM, [policyChangeVM]);

    /**
     * Define property overrides for this Jutro component.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showOptional: true,
            labelPosition: 'top',
            readOnly: true
        },
        thirdPartyInterestPageLoadingIndicator: {
            loaded: true
        },
        thirdPartyInterestPageContainer: {
            visible: true
        },
        e1ptpiDisplayTableContainer: {
            transactionVM: policyChangeVM,
            viewModelService,
            authHeader,
            updateWizardData,
            setIsSavingTPI: () => { },
            showErrors: false,
            onValidate,
            disregardFieldValidationParentPage: () => { },
            viewOnlyMode: true
        }
    };

    /**
     * Helper callback for reading values from the view model.
     */
    const readValue = useCallback(
        (id, path) => readViewModelValue(
                metadata.pageContent,
                policyChangeVM,
                id,
                path,
                overrideProps
            ),
        [overrideProps, policyChangeVM]
    );

    /**
     * Define rendering behaviors for this Jutro component.
     */
    return (
        <WizardPage
            onNext={onNext}
            shouldLink
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={policyChangeVM}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                overrideProps={overrideProps}
                resolveValue={readValue}
            />
        </WizardPage>
    );
}

ViewThirdPartyInterestPage.propTypes = wizardProps;
export default ViewThirdPartyInterestPage;
